import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/ServiceCategories";
import getToken from "app/api/getToken";
import { IService } from "app/api/types";

export const GET_SERVICES_CATEGORY_REQUEST = "GET_SERVICES_CATEGORY_REQUEST";
export const GET_SERVICES_CATEGORY_SUCCESS = "GET_SERVICES_CATEGORY_SUCCESS";
export const GET_SERVICES_CATEGORY_FAIL = "GET_SERVICES_CATEGORY_FAIL";

export const getServiceCategories = () => (dispatch: any): any => {
  dispatch({ type: GET_SERVICES_CATEGORY_REQUEST });

  const token = getToken();

  return api
    .getServiceCategories(token)
    .then((response: AxiosResponse) => {
      const serviceCategoriesList: IService[] = get(response, "data", {});
      dispatch({
        type: GET_SERVICES_CATEGORY_SUCCESS,
        payload: serviceCategoriesList
      });

      return serviceCategoriesList;
    })
    .catch(err => {
      dispatch({
        type: GET_SERVICES_CATEGORY_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
